// Money is integer paise on the backend. Format for Indian display (₹, lakh grouping).
export function formatPaise(paise: number): string {
  const rupees = paise / 100;
  return '₹' + rupees.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

// parse a rupee string (e.g. "1200.50") to integer paise
export function toPaise(rupees: string | number): number {
  const n = typeof rupees === 'number' ? rupees : parseFloat(rupees.replace(/,/g, ''));
  if (isNaN(n)) return 0;
  return Math.round(n * 100);
}

export function formatDate(iso: string | null): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
}
